import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, Text, StyleSheet, Dimensions } from 'react-native';
import Modal from 'react-native-modal';

import Colors from '../../constants/Colors';
import Layout from '../../constants/Layout';
import FilledButton from '../FilledButton';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  contentContainer: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginVertical: 'auto',
    backgroundColor: Colors.white,
    width: Layout.isSmall ? 280 : 320,
    maxHeight: Layout.isSmall ? 300 : 300,
    paddingVertical: 26,
    paddingHorizontal: 36,
    textAlign: 'center',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerText: {
    fontSize: Layout.isSmall ? 16 : 20,
    fontWeight: '500',
  },
  text: {
    fontSize: 14,
    width: 180,
    marginBottom: 20,
  },
  spacer: {
    height: 10,
  },
});

class MustLogin extends PureComponent {
  static propTypes = {
    translation: PropTypes.objectOf(PropTypes.any).isRequired,
    onOk: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
  };

  render() {
    const { translation, onOk, onCancel } = this.props;

    const deviceWidth = Dimensions.get('window').width;
    const deviceHeight = Dimensions.get('window').height;

    return (
      <View style={styles.container}>
        <Modal isVisible deviceWidth={deviceWidth} deviceHeight={deviceHeight} statusBarTranslucent>
          <View style={styles.contentContainer}>
            <Text style={styles.headerText}>{translation.action_required}</Text>
            <Text style={styles.text}>{translation.please_sign_in_or_up}</Text>
            <FilledButton
              onPress={onOk}
              label={translation.sign_in_or_up}
              color={Colors.darkGreen}
              full
              textColor={Colors.white}
              testID="open-profile"
            />
            <View style={styles.spacer} />
            <FilledButton
              onPress={onCancel}
              label={translation.app_button_cancel}
              color={Colors.darkGreen}
              full={false}
              testID="cancel-profile"
            />
          </View>
        </Modal>
      </View>
    );
  }
}

export default MustLogin;
